import { OrchestratorTopology } from "../OrchestratorTopology.js";

export interface OrchestratorConfiguration {
    topology: OrchestratorTopology;
}
